import {
  Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges,
} from '@angular/core';
import { Select, SelectChangeEvent } from 'primeng/select';
import { AbstractFilterElementComponent, FilterEmitterType } from './abstract-filter-element.component';
import { FilterElementSize, gridClassesForFilterElementSize } from './filter-elements';
import { FloatLabel } from 'primeng/floatlabel';
import { MultiSelect } from 'primeng/multiselect';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'selection-filter-element',
  templateUrl: './selection-filter-element.component.html',
  styleUrl: './selection-filter-element.component.scss',
  imports: [
    FormsModule,
    TranslatePipe,
    FloatLabel,
    Select,
    MultiSelect,
  ],
})
export class SelectionFilterElementComponent extends AbstractFilterElementComponent implements OnChanges {
  @HostBinding('class')
  override componentClass = '';

  @Input()
  override size: FilterElementSize = FilterElementSize.MEDIUM;

  @Input()
  override label = '';

  @Input()
  override filterActive = false;

  @Input()
  override filterKey!: string;

  @Input()
  multiple = false;

  @Input()
  shouldTranslate = true;

  @Input()
  totalValues: number | undefined;

  @Input()
  values: Record<string, string> = {};

  @Input()
  searchable = false;


  @Output()
  override filterTerm: EventEmitter<FilterEmitterType> = new EventEmitter();

  @Output()
    searchTerm: EventEmitter<string | undefined> = new EventEmitter();

  options: { key: string; value: string }[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['size']) {
      this.componentClass = gridClassesForFilterElementSize(changes['size'].currentValue);
    }
    if (changes['values']) {
      this.options = Object.entries(this.values).map(([key, value]) => ({ key, value }));
    }
    if (changes['filterActive']) {
      this.value = changes['filterActive'].currentValue ? this.value : null;
    }
  }

  override onFilterChange(changes: SelectChangeEvent | null) {
    if (!changes?.value || (this.multiple && changes.value.length === 0)) {
      this.filterTerm.emit({
        key: this.filterKey,
        term: undefined,
      });
      return;
    }

    if (this.multiple) {
      this.filterTerm.emit({
        key: this.filterKey,
        term: changes.value && changes.value.length > 0 ? `${this.filterKey}:${changes.value.join(';')}-and` : undefined,
      });
    } else {
      this.filterTerm.emit({
        key: this.filterKey,
        term: changes.value ? `${this.filterKey}:${changes.value}-and` : undefined,
      });
    }
  }

  protected onFilterTermChange(term: string | undefined) {
    if (!this.searchable) {
      return;
    }
    if (term) {
      this.searchTerm.emit(term);
    } else {
      this.searchTerm.emit(undefined);
    }
  }

  protected getLength(): number {
    return this.values ? Object.keys(this.values).length : 0;
  }
}